import { render } from "./NewLocationComponent.vue?vue&type=template&id=223f575e&scoped=true"
import script from "./NewLocationComponent.vue?vue&type=script&lang=js"
export * from "./NewLocationComponent.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-223f575e"

export default script